import ApiService from '../apiservice'

export default class UploadAtividadeService extends ApiService {

  constructor() {
    super('/uploadAtividade')
  }

  uploadTemp(formData) {
    return this.post('/temp',formData);
  }

  upload(formData) {
    return this.post('/',formData);
  }
}